// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.encounter.assessment.UpdateAssessmentRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdateAssessmentRequest extends GandalfModelBase {

	@GandalfValidator({ notNull: { message: 'Assessment Id must not be null' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	assessmentId!: number;

	@GandalfValidator({ sizeString: { message: 'The Assessment Comments cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	comment!: string | null;

}
